import { getCountry } from '@shared/helpers';
import { useAuth } from '../../+auth';

export const useCountry = (): GenericTypes.Country => {
  const { dataSource } = useAuth();

  return getCountry(dataSource);
};
